//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VipLevel from '../../../components/VipLevel'
import IconVipTips from './components/IconVipTips'

export default {
  props: ['vipInfo'],
  computed: {
    vip () {
      return this.vipInfo || {}
    },
    current () {
      return this.vip.vipLevel || 0
    },
    next () {
      return this.current + 1;
    },
    points () {
      return this.vip.continuePoints || 0 
    },
    progress () {
      return (
        (
          this.vip.upPoints
          -
          this.vip.continuePoints
        )
        /
        (this.vip.upPoints || 1)
      ) * 100
    },
  },
  components: {
    VipLevel,
    IconVipTips,
  }
}




// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Base/components/VipInfo/index.bak.vue